import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import logoutImage from '../assets/images/logout.svg';

type LogoutConfirmDialogProps = {
  open: boolean;
  onCancel: () => void;
  onClose: () => void;
  onConfirm: () => void;
};

const LogoutConfirmDialog = ({ open, onCancel, onClose, onConfirm }: LogoutConfirmDialogProps) => {
  const { t } = useTranslation('patient-transport');

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('logoutConfirmDialog.title')}</DialogTitle>
      <DialogContent>
        <Stack alignItems="center" spacing={3} textAlign="center">
          <img src={logoutImage} alt="logout image" />
          <DialogContentText>{t('logoutConfirmDialog.content')}</DialogContentText>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onConfirm} autoFocus>
          {t('confirm', { ns: 'common' })}
        </Button>
        <Button onClick={onCancel} variant="outlined">
          {t('cancel', { ns: 'common' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutConfirmDialog;
